//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* eslint-disable no-unused-vars */
import flatpickr from "flatpickr";
import flatpickrStyles from "flatpickr/dist/flatpickr.min.css";
/* eslint-enable no-unused-vars */

export default {

    data() {
        return {
            category: '',
            keywords: '',
            dateRangePicker: ''
        }
    },

    props: {
      heading: {
        type: String,
        default: '',
        required: false,
      },
      categories: Array,
      displaySearchBtn: Boolean,
      displayDateRange: Boolean,
      selectedCategory: [ Number, String ],
      displayResetBtn: Boolean,
      displayKeywords: {
        type: Boolean,
        default: true,
        required: false,
      },
      formAction: {
        type: String,
        default: '',
        required: false,
      },
      formMethod: {
        type: String,
        default: '',
        required: false,
      }
    },

    watch: { 
      selectedCategory: function(newVal) { // watch selectedCategory so we can get the initial prop value (if a prop needs to be calculated it may not be available until after this component is mounted)
        this.category = newVal;
      }
    },

    created() {
        this.category = this.selectedCategory; // this wont work if the selectedCategory prop needs to be calculated, because this will run before we even get the final prop value, which is why I added the watcher aswell
    },

    mounted() {
        if(this.displayDateRange) {
             
            let datePicker = document.getElementById("filter-date-picker");
            let _this = this;

            //flatpickr(".flatpickr", {
            this.dateRangePicker = flatpickr(datePicker, {
                mode: "range",
                altInput: true,
                altFormat: "d/m/Y", //format for display only
                //onChange: function(selectedDates, dateStr, instance) {
                onChange: function(selectedDates) {

                    if(selectedDates.length>1) { // emit event only when both dates selected

                        let dateRanges = [];
                        dateRanges.push(flatpickr.formatDate(selectedDates[0], "Y-m-d"));
                        dateRanges.push(flatpickr.formatDate(selectedDates[1], "Y-m-d"));

                        //_this.$emit('update:daterange', selectedDates);
                        _this.$emit('update:daterange', dateRanges);
                    } else if (selectedDates.length == 0) { // they've just deleted the date
                        _this.$emit('update:daterange', []); // sent empty sarray
                    }
                }
            });
        }
    },

    methods : {
        appClasses() {
            let cssClass=[];

            if(this.categories.length > 0)
                cssClass.push("filter--with-categories");

            if(this.displayDateRange)
                cssClass.push("filter--with-date");

            if(this.displaySearchBtn)
                cssClass.push ("filter--with-submit");

            return cssClass;
        },
        resetForm(){
            this.category = this.keywords = this.dateRange = '';

            if(this.displayDateRange)
                this.dateRangePicker.clear(false); //dont triggerChangeEvent, the reset event below should habdle the event

            this.$emit('click:reset', '');
        }
    },
    
}



// WEBPACK FOOTER //
// ./scripts/vue/SearchFilter.vue